import {PaginationMeta} from '../../api/types';

export const isLastPage = (meta: PaginationMeta) => {
	return meta.pagination.page === meta.pagination.pageCount;
};

export const startPage = 1;
